<app-widget-option [categories]="['LAYERS']" [label]="'TARGET'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-number [value]="widgetLayers.layer(current).gaugeTarget" (sendValue)="receiveValue($event)" [color]="color" [step]="20"></app-number>
  </div>
</app-widget-option>